import MultiTextLink from './component.jsx'
export default MultiTextLink
